<!--    
    The sliders etc for Alarms and the save Button. Only Hydranten for now??   
    Maybe split the possible alarms depending on wether they are a Boolean:
        Boolean:  Möglichkeiten sind Bool1 Bool0
        Not Boolean: Möglichkeiten = Eingabe Felder für Min bzw Max. Beide setzbar in einem Alarm!


-->
<!--Copy right - © 2024 tecera gmbh-->

<script>
    import {
        selected_device,
        toast_message,
        all_hymos,
        all_compound_water_meters,
    } from "../stores.js";
    import AlarmAuswahlElement from "./AlarmAuswahlElement.svelte";
    import { onDestroy, onMount } from "svelte";
    import { BASE_API_URL } from "../config.js";
    import { user_permissions, logout, user_role } from "../scripts/auth.js";

    import GrenzwertDefaultsButton from "./buttons/GrenzwertDefaultsButton.svelte";

    export let many = false;
    export let is_disabled=false;

    let fake_id = -1;
    let channels_copy = []; // Copy of the channels to save the changes


    // creates a copy of the channels to save the changes. If no alarm is given, a new alarm is created
    // Alarme für Non Bools ändern
    $: {
        // creating copy of the channels so we can save (or reset) changes
        if ($selected_device) {
            create_channel_list();
        }
    }

    function create_channel_list() {
        // watermeters
        // always use Volumeflow as a compound alarm
        if (many) {
            // creation of fake channel for Volumeflow
            let volume_flow_alarm;
            if ($selected_device.alarms && $selected_device.alarms.length > 0) {
                volume_flow_alarm = $selected_device.alarms[0];
            } else {
                volume_flow_alarm = {
                    min_alarm_active: 0,
                    max_alarm_active: 0,
                    min_threshold: null,
                    max_threshold: null,
                    autoquit: 0,
                };
            }
            channels_copy = [
                {
                    alarms: [volume_flow_alarm],
                    boolean_0: null,
                    boolean_1: null,
                    measurand: "Volumenstrom",
                    name: "volume_flow",
                    unit: "m³/h",
                    id: fake_id--,
                },
            ];
            if ($selected_device.watermeterconfigs) {
                // adding real channels
                $selected_device.watermeterconfigs.forEach((watermeter) => {
                    watermeter.channels.forEach((channel) => {
                        if (
                            channel.measurand != "Zählerstand" &&
                            channel.measurand != "Volumenstrom"
                        )
                            channels_copy.push(
                                JSON.parse(JSON.stringify(channel)),
                            );
                    });
                });
            } else {
                channels_copy = [];
            }
            // many==false -> hymos
        } else {
            if (!$selected_device.channels) {
                channels_copy = [];
            } else {
                channels_copy = [];

                channels_copy = JSON.parse(
                    JSON.stringify($selected_device.channels),
                );
            }
        }

        channels_copy.forEach((channel) => {
            if (!channel.alarms || channel.alarms.length == 0) {
                channel.alarms = [];
                let alarm = {
                    channel_id: channel.id,
                    min_alarm_active: 0,
                    max_alarm_active: 0,
                    autoquit: 0,
                };
                channel.alarms.push(alarm);
            }
        });
    }

    async function update_alarms() {
        let url_extension = `/alarm_update/${$selected_device.id}/`;
        let request_url = BASE_API_URL + url_extension;

        timeout_button();

        let device_copy = JSON.parse(JSON.stringify($selected_device));
        device_copy.channels = channels_copy;
        try {
            const response = await fetch(request_url, {
                method: "PATCH",
                headers: {
                    Authorization: `Token ${sessionStorage.getItem(
                        "2kai_access_token",
                    )}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(device_copy),
            });
            if (response.status === 200) {
                refresh_hymo();
                $toast_message = " Alarm erfolgreich editiert";
            }
            return false;
        } catch (error) {
            return false;
        }
    }

    async function refresh_hymo() {
        let url_extension = `/hymo_configs/${$selected_device.id}/`;
        let request_url = BASE_API_URL + url_extension;
        try {
            const response = await fetch(request_url, {
                method: "GET",
                headers: {
                    Authorization: `Token ${sessionStorage.getItem(
                        "2kai_access_token",
                    )}`,
                    "Content-Type": "application/json",
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            let api_result = await response.json();
            $all_hymos.forEach((hymo, idx) => {
                if (hymo == $selected_device) {
                    hymo.channels = api_result.channels;
                } else {
                }
            });
            return true;
        } catch (error) {
            return false;
        }
    }

    async function refresh_compound_water_meter() {
        let url_extension = `/compound_water_meters/${$selected_device.id}/`;
        let request_url = BASE_API_URL + url_extension;
        try {
            const response = await fetch(request_url, {
                method: "GET",
                headers: {
                    Authorization: `Token ${sessionStorage.getItem(
                        "2kai_access_token",
                    )}`,
                    "Content-Type": "application/json",
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            let api_result = await response.json();
            $all_compound_water_meters.forEach((compound, idx) => { // TODO: this might not work and create multiple alarms if we dont reload the alarm page
                if (compound == $selected_device) {
                    compound.alarms = api_result.alarms;
                    compound.watermeterconfigs.forEach((watermeter, idx2) => {
                        watermeter.channels =
                            api_result.watermeterconfigs[idx2].channels;
                    });
                } 
            });
            return true;
        } catch (error) {
            return false;
        }
    }

    async function update_alarms_water_meter() {
        let url_extension = `/alarm_update_water_meter/${$selected_device.id}/`;
        let request_url = BASE_API_URL + url_extension;
        
        timeout_button();
        let device_copy = JSON.parse(JSON.stringify($selected_device));
        device_copy.channels = channels_copy;
        try {
            const response = await fetch(request_url, {
                method: "PATCH",
                headers: {
                    Authorization: `Token ${sessionStorage.getItem(
                        "2kai_access_token",
                    )}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(device_copy),
            });
            if (response.status === 200) {
                refresh_compound_water_meter();
                $toast_message = " Alarm erfolgreich editiert";
            } else {
            }
            return true;
        } catch (error) {
            return false;
        }
    }

    function handle_update_click() {
        if (is_disabled) {
            return;
        }
        if (many) {
            update_alarms_water_meter();
        } else {
            update_alarms();
        }
    }

    let is_button_disabled = false;
    function timeout_button(){
        is_button_disabled = true;
        setTimeout(() => {
            is_button_disabled = false;
        }, 500);
    }
</script>

<div id="sensor_grenzwerte">
    {#each channels_copy as channel (channel.id)}
        <AlarmAuswahlElement bind:channel />
    {/each}
</div>

{#if $user_role["set_alarm"] && $user_role["set_alarm"] == 1}
    <div class="input-group mb-2 mt-4">
        <!-- <button
            class="btn btn-secondary btn-block "
            disabled={is_button_disabled}
        >
            Standard Grenzwerte bearbeiten
        </button> -->
    </div>

    <div class="input-group mb-2 mt-4">
        <button
            class="btn btn-primary btn-block "
            id="save_grenzwerte"
            disabled={is_button_disabled || channels_copy.length == 0}
            on:click={() => handle_update_click()}
        >
            Speichern
        </button>
    </div>
{/if}
